/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_ActiveInputs */

const cs_projects_active = /** @type {(inputs: Projects_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní na Sreality`)
};

const en_projects_active = /** @type {(inputs: Projects_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active on Sreality`)
};

/**
* | output |
* | --- |
* | "Active on Sreality" |
*
* @param {Projects_ActiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_active = /** @type {((inputs?: Projects_ActiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_ActiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_active(inputs)
	return cs_projects_active(inputs)
});